import {
  canEditOrgLibraryItem,
  isSystemLibraryItem,
  type OrgLibraryAccessOptions,
  type OrgLibraryItem,
} from "@/lib/libraryAccess";

export const isSystemExercise = (exercise: Pick<OrgLibraryItem, "org_id">) =>
  isSystemLibraryItem(exercise);

export const canEditExerciseDetails = canEditOrgLibraryItem;

export const canEditExerciseVideo = (
  exercise: OrgLibraryItem | undefined,
  options: OrgLibraryAccessOptions,
) => {
  if (!exercise) {
    return true;
  }
  if (isSystemExercise(exercise)) {
    return options.canManageLibrary;
  }
  return canEditExerciseDetails(exercise, options);
};

export const canDeleteExercise = canEditExerciseDetails;
